<template>
  <div class="row q-col-gutter-md">
    <milestone-dependencies v-if="dependencies" :dependencies="dependencies" />
    <milestone-messages
      v-if="messages"
      :subscription-period-id="subscriptionPeriodId"
      :messages="messages"
      :config="config"
    >
      <template #actions>
        <template v-if="meta.status === 'pending'">
          <RBtn type="primary" size="small" class="q-mt-sm" @click="openTask(meta.system_name)">
            Complete task in workflow
          </RBtn>
        </template>
      </template>
    </milestone-messages>
    <template v-if="isCompletedOrDismissed">
      <template v-if="hasContent">
        <slot v-if="meta.status === 'completed'" name="content-completed" />
        <div v-else-if="meta.status === 'dismissed'" class="col-xs-12">
          <milestone-dismissed :data="data" :subscription-period-id="subscriptionPeriodId" />
        </div>
      </template>
      <milestone-no-data-available v-else />
    </template>
  </div>
</template>

<script>
import MilestoneDependencies from '@/components/milestones/MilestoneDependencies'
import MilestoneMessages from '@/components/milestones/MilestoneMessages'
import MilestoneDismissed from '@/components/milestones/MilestoneDismissed'
import MilestoneNoDataAvailable from '@/components/milestones/MilestoneNoDataAvailable'
import MilestoneMixin from '@/mixins/milestone.mixin'

export default {
  name: 'MilestoneWrapper',
  components: {
    MilestoneDependencies,
    MilestoneMessages,
    MilestoneDismissed,
    MilestoneNoDataAvailable
  },
  mixins: [MilestoneMixin],
  props: {
    data: {
      type: Object,
      required: true
    },
    meta: {
      type: Object,
      required: true
    },
    subscriptionPeriodId: {
      type: Number,
      required: true
    }
  },
  methods: {
    openTask(name) {
      this.$root.$emit('open-task', name)
    }
  }
}
</script>
